const initialState = {
	data: [],
	total: 0,
	params: {},
	selected: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const originalgamehistory = (state = initialState, action) => {
	switch (action.type) {
		case 'ORIGINALGAMEHISTORY_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'ORIGINALGAMEHISTORY_GET_CURRENT':
			return {
				...state,
				selected: action.selected,
			}
		case 'ORIGINALGAMEHISTORY_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default originalgamehistory
